import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, Card, Grid, TextField, Typography, IconButton } from '@mui/material';
import { Controller, useForm, useFieldArray } from 'react-hook-form';
import { UserProfileContext } from '../UserProfile';
import { Add as AddIcon, Delete, Remove as RemoveIcon } from '@mui/icons-material';
import { ProviderServices } from '../CrudServices';
import { resetServerContext } from 'react-beautiful-dnd';
import Swal from 'sweetalert2';
import Loading from '../../../components/Loader/Loading'
import { Helpers } from '../../../services/Helpers';
import { LocalStore } from '../../../storage/authStore';

const BusinessDetails = ({ businessDetailsData }) => {
    const isSuperAdmin = LocalStore.getLoggedUserDetails()?.role?.title?.toString().trim().toLowerCase().replace(/[\s_-]+/g, '') === 'superadmin';
    const viewImage = (image) => {
        if (!isSuperAdmin) {
            return Swal.fire('Permission denied', 'You do not have permission to view PAN or Aadhaar images. Please contact the support team.', 'warning');
        }
        // using swal to view image...not close on outside click
        Swal.fire({
            html: `<div style="text-align:left;font-size: 0.9rem; font-weight: 500; color: #333;">${image}</div><img src="${Helpers.ImagePathUrl()}/profile/lg/${image}" alt="PAN Image" style="width:100%;height:auto;margin-top:1rem"/>`,
            showCloseButton: true,
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} lg={7}>
                <Card sx={{ borderTopRightRadius: 0 }}>
                    <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                        <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Business Info</Typography>
                    </Box>
                    <Grid container spacing={1} sx={{p:'2%'}}>
                        <Grid item xs={12} sx={{}}>
                            <Typography sx={{ width: '60%', fontWeight: '600', fontSize: '.75rem' }}>Business Name</Typography>
                            <TextField
                                disabled
                                inputProps={{
                                    style: { fontSize: '.75rem' }
                                }}
                                value={businessDetailsData?.businessName || ''}
                                fullWidth
                                sx={{}}
                                size='small'
                            />
                        </Grid>
                        <Grid item xs={12} sx={{}}>
                            <Typography sx={{ width: '60%', fontWeight: '600', fontSize: '.75rem' }}>Business Email</Typography>

                            <TextField
                                disabled
                                inputProps={{
                                    style: { fontSize: '.75rem' }
                                }}
                                value={businessDetailsData?.businessEmail || ''}
                                sx={{}}
                                fullWidth
                                size='small'
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{}}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.75rem' }}>Business Mobile Number </Typography>

                                <TextField
                                    fullWidth
                                    disabled
                                    inputProps={{
                                        style: { fontSize: '.75rem' }
                                    }}
                                    value={businessDetailsData?.businessMobileNumber || ''}
                                    size='small'
                                />
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{}}>
                            <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Gst Number</Typography>

                            <TextField
                                disabled
                                inputProps={{
                                    style: { fontSize: '.75rem' }
                                }}
                                value={businessDetailsData?.gstNumber || ''}
                                type="text"
                                fullWidth
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{}}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.75rem' }}>
                                    PAN Number</Typography>

                                <TextField
                                    disabled
                                    inputProps={{
                                        style: { fontSize: '.75rem' }
                                    }}
                                    value={businessDetailsData?.panNumber || ''}
                                    type="text"
                                    fullWidth
                                    size="small"
                                />
                                {(businessDetailsData.panImage) && <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue' }} onClick={() => viewImage(businessDetailsData.panImage)}>View PAN Image</Typography>}
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{}}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.75rem' }}>
                                    Aadhaar Number
                                </Typography>
                                <TextField
                                    disabled
                                    inputProps={{
                                        style: { fontSize: '.75rem' }
                                    }}
                                    value={businessDetailsData?.aadharNumber || ''}
                                    type='text'
                                    fullWidth
                                    size='small'
                                />
                                {(businessDetailsData.aadharFrontImage) && <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue' }} onClick={() => viewImage(businessDetailsData.aadharFrontImage)}>View Aadhar Front</Typography>}
                                {(businessDetailsData.aadharRearImage) && <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue' }} onClick={() => viewImage(businessDetailsData.aadharRearImage)}>View Aadhar Rear Image</Typography>}
                            </Grid>
                    </Grid>
                </Card>
            </Grid>
            <Grid item xs={12} lg={5}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card sx={{ borderTopLeftRadius: 0 }}>
                            <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>UPI Details</Typography>
                            </Box>
                            <Box sx={{ p: '1% 2%' }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.85rem', mb: 1 }}>UPI IDs</Typography>
                                {businessDetailsData?.upiId && businessDetailsData?.upiId.map((upi, index) => (
                                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>

                                        <TextField
                                            disabled
                                            inputProps={{
                                                style: { fontSize: '.75rem' }
                                            }}
                                            value={upi || ''}
                                            fullWidth
                                            size="small"
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ borderTopLeftRadius: 0 }}>
                            <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Bank Details</Typography>
                            </Box>
                            <Box sx={{ p: '1% 2%' }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Bank Name</Typography>
                                <TextField
                                    disabled
                                    inputProps={{
                                        style: { fontSize: '.75rem' }
                                    }}
                                    value={businessDetailsData?.bankName || ''}
                                    fullWidth
                                    size="small"
                                />
                            </Box>
                            <Box sx={{ p: '1% 2%' }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Account Holder Name</Typography>
                                <TextField
                                    disabled
                                    inputProps={{
                                        style: { fontSize: '.75rem' }
                                    }}
                                    value={businessDetailsData?.beneficiaryName || ''}
                                    fullWidth
                                    size="small"
                                />
                            </Box>
                            <Box sx={{ p: '1% 2%' }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>IFSC Code</Typography>
                                <TextField
                                    disabled
                                    inputProps={{
                                        style: { fontSize: '.75rem' }
                                    }}
                                    value={businessDetailsData?.ifscCode || ''}
                                    fullWidth
                                    size="small"
                                />
                            </Box>
                            <Box sx={{ p: '1% 2%' }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Account Number</Typography>
                                <TextField
                                    disabled
                                    inputProps={{
                                        style: { fontSize: '.75rem' }
                                    }}
                                    value={businessDetailsData?.accountNumber || ''}
                                    fullWidth
                                    size="small"
                                />
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default BusinessDetails;
